import { render, staticRenderFns } from "./PscQuestionnaire.vue?vue&type=template&id=10f59762&scoped=true&"
import script from "./PscQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./PscQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f59762",
  null
  
)

export default component.exports